<template>
  <div style="width: 100%; height: 100%">
    <div class="dynamic-content1">
      <div class="dynamic-content1-video">
        <div class="dynamic-title">{{ $t("langcfg.txtDynamicVideo") }}</div>
        <PupilCorneaVideo
          :width="dispW * 0.6 * videoWidth"
          :height="dispW * 0.6 * videoWidth * (768 / 1024)"
          :src="puilCorneaData.media"
          :record="currentRecord"
          :currentEye="currentEye"
          :realTotalTime="-1"
          :pupilDiameterData="puilCorneaData.resultPupilDiameter"
          :pupilCenterX="puilCorneaData.resultPupilCenterX"
          :pupilCenterY="puilCorneaData.resultPupilCenterY"
          :ringCenterX="puilCorneaData.ringCenterX"
          :ringCenterY="puilCorneaData.ringCenterY"
        />
      </div>
      <div class="dynamic-content1-imagexy">
        <div class="dynamic-title">{{ $t("langcfg.txtXYGraph") }}</div>
        <PupilConeaXy
          :width="dispW * 0.6 * 0.43"
          :height="(dispH - 60 - 80) * 0.5"
          :pupilCenterX="puilCorneaData.resultPupilCenterX"
          :pupilCenterY="puilCorneaData.resultPupilCenterY"
          :ringCenterX="puilCorneaData.ringCenterX"
          :ringCenterY="puilCorneaData.ringCenterY"
          :coordinateSystem="coordinateSystem"
        />
      </div>
    </div>
    <div class="dynamic-content2">
      <div class="dynamic-title" style="line-height: 80px">
        {{ $t("langcfg.txtPupilDiameterChange") }}
      </div>
      <PupilConeaChart
        :width="dispW * 0.62"
        :height="(dispH - 60 - 80) * 0.45 - 20"
        :pupilDiameterData="puilCorneaData.resultPupilDiameter"
        :pupilCalIndex="pupilCalIndex"
      />
    </div>
  </div>
</template>

<script>
import PupilCorneaVideo from "./PupilConeaVideo.vue";
import PupilConeaChart from "./PupilConeaChart.vue";
import PupilConeaXy from "./PupilConeaXY.vue";
import { hasKey, isEqual, logStdout, objectCopy } from "../../shared/utils";
import { isDataValid, isDefined } from "../shared";

export default {
  name: "PupilCorneaDynamic",
  props: {
    currentRecord: {
      type: Object,
      default: function () {
        return {};
      }
    },
    currentEye: {
      type: String,
      default: ""
    },
    currentMode: {
      type: String,
      default: ""
    },
    dispW: {
      type: Number,
      default: 500
    },
    dispH: {
      type: Number,
      default: 500
    },
    puilCorneaData: {
      type: Object,
      default: function () {
        return {};
      }
    },
    pupilCalIndex: {
      type: Number,
      default: 0
    },
    coordinateSystem: {
      type: String,
      default: "rectangular"
    }
  },
  components: {
    PupilCorneaVideo,
    PupilConeaChart,
    PupilConeaXy
  },
  data: function () {
    return {
      src: "",
      videoWidth: window.copyScreen ? 0.48 : 0.56
    };
  },
  methods: {
    _initPhoto() {
      if (hasKey(this.currentRecord, `content.data${this.currentEye}.dynamicpupil.photos`)) {
        let photos = this.currentRecord.content[`data${this.currentEye}`]["dynamicpupil"]["photos"];
        let photo = photos[0];
        return photo;
      }
      return undefined;
    },
    initPhoto() {
      const { serverip, serverport, sslport, serverssl } = window.server || {};
      let protocol = serverssl === 1 ? "https:" : "http:";
      let port = serverssl === 1 ? sslport : serverport;
      let photo = this._initPhoto();
      return isDefined(photo)
        ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}`
        : "";
    }
  },
  mounted() {
    this.src = this.initPhoto();
  }
};
</script>

<style lang="less" scoped>
.dynamic-title {
  text-align: left;
  font-size: 28px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
}
.dynamic-content1 {
  width: 100%;
  height: 55%;
  display: flex;
  justify-content: space-between;
  &-video {
    width: 52%;
    height: 100%;
  }
  &-imagexy {
    width: 43%;
    height: 100%;
  }
}

.dynamic-content2 {
  width: 100%;
  height: 45%;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/PupilCorneaDynamic.vue